// extracted by mini-css-extract-plugin
export default {"icon-wrapper":"NetworkOption_icon-wrapper__6VZ6W"};